import axios from 'axios';

export default class TwilioService {
  public static async callPhone(
    documentId: string,
    recipientId: string,
    authId: string,
    phoneNumber: string
  ): Promise<{
    status: string;
    callSid: any;
  }> {
    const body: FormData = new FormData();
    body.append('phone-number', phoneNumber);

    const url = `/view/${documentId}/${recipientId}/${authId}/call`;
    const {
      data: { status, call_sid },
    } = await axios.post(url, body);

    return { status, callSid: call_sid };
  }

  public static async cancelCall(
    documentId: string,
    recipientId: string,
    authId: string,
    callSid: string
  ): Promise<any> {
    const body: FormData = new FormData();
    body.append('call_sid', callSid);

    const url = `/view/${documentId}/${recipientId}/${authId}/hangup`;
    const { data } = await axios.post(url, body);

    return data;
  }
}
